// Source: https://github.com/tkww/organizer-frontend/blob/qa/app/middlewares/logout_member.js

import * as membership from '@xo-union/store-membership-redux';
import type { Middleware } from 'redux';

export default (): Middleware => {
  return () => (next) => (action) => {
    const result = next(action);
    // A logout action is dispatched by the Union Header component when a user uses it to log out.
    if (action.type === membership.LOG_OUT_SUCCESS) {
      // We listen for the successful logout action and redirect the user to the logged out homepage.
      window.location.replace('/');
    }

    return result;
  };
};
